type user  = {
    Id:number,
    Name:string,
    Name_ar:string,
    Email:string,
    Img:string,
    Serial:string,
    Points:number,
    Role_id:number,
    Phone:string,
    Breif:string,
    Website:string,
    Instagram:string,
    Twitter:string,
    Role:string,
    Color:string,
    Password:string,
}


export const userPlaceholder:user = {
    Id:0,
    Name:"",
    Name_ar:"",
    Email:"",
    Img:"",
    Serial:"",
    Points:0,
    Role_id:0,
    Phone:"",
    Breif:"",
    Website:"",
    Instagram:"",
    Twitter:"",
    Role:"",
    Color:"",
    Password:"",
}
export default user 
